import { produce, type Draft } from 'immer';
import { useCallback, useMemo, useState } from 'react';

export function useImmerState<TData>(initialState: TData | (() => TData)) {
  const [state, setState] = useState(initialState);
  const produceBids = useCallback((recipe: (draft: Draft<TData>) => void) => {
    setState((current) => produce(current, recipe));
  }, []);

  return useMemo(() => [state, produceBids] as const, [state, produceBids]);
}
